/* ============================================================
   PBK Customer Voice — Yotpo 公開 read API からレビュー取得しカスタム UI で描画
   ------------------------------------------------------------
   - ウィジェット埋込は使わず fetch + カスタムマークアップ
   - 公開 app_key のみで完結する read API を使用（秘密トークン utoken はフロントに出さない）
   - fetch 失敗 / 0件時はセクション非表示（hidden 属性を維持）
   ------------------------------------------------------------
   ⚠ 要 Yotpo 公式ドキュメント確認: 下記エンドポイント定数は公開 API 準拠だが
      現場の app_key / プラン差異で応答形が変わりうる。ENDPOINTS で切替可能にしてある。
      公式リファレンス（要確認）:
        - Site reviews (widget/{app_key}/products/yotpo_site_reviews/reviews.json)
        - Product reviews (widget/{app_key}/products/{product_id}/reviews.json)
   ============================================================ */
(function () {
  'use strict';

  /* ---- エンドポイント定数（切替可能・要 Yotpo 公式ドキュメント確認） ---- */
  var YOTPO_CDN = 'https://api-cdn.yotpo.com/v1/widget';
  var ENDPOINTS = {
    // サイト全体レビュー: yotpo_site_reviews は Yotpo のサイトレビュー用 pseudo product id
    site: function (appKey) {
      return YOTPO_CDN + '/' + encodeURIComponent(appKey) + '/products/yotpo_site_reviews/reviews.json';
    },
    // 商品レビュー: product_id 単位
    product: function (appKey, productId) {
      return YOTPO_CDN + '/' + encodeURIComponent(appKey) + '/products/' + encodeURIComponent(productId) + '/reviews.json';
    }
  };

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function clampScore(v) {
    var n = Math.round(parseFloat(v));
    if (isNaN(n)) return 0;
    return Math.max(0, Math.min(5, n));
  }

  // 日付 → 2026.4.29 形式（前ゼロなし）
  function formatDate(raw) {
    if (!raw) return '';
    var d = new Date(raw);
    if (isNaN(d.getTime())) return '';
    return d.getFullYear() + '.' + (d.getMonth() + 1) + '.' + d.getDate();
  }

  var STAR_PATH = 'M8 .8l1.9 4.34 4.72.42-3.57 3.12 1.06 4.62L8 10.9l-4.11 2.42 1.06-4.62L1.38 5.56l4.72-.42z';
  /* viewBox はグリフの bbox(x1.38-14.62 / y0.8-13.32)を Figma の星インセット
     (L/R 4.55% ・上 2.27% ・下 11.17%)に一致させ、箱いっぱいに描く。
     旧 "0 0 16 16" は約20%の余白でグリフが小さく見えていた（レビュー 1852871714）。 */
  var STAR_VIEWBOX = '0.72 0.47 14.57 14.46';

  function starsSvg(score) {
    var full = clampScore(score);
    var out = '';
    for (var i = 0; i < 5; i++) {
      var cls = i < full ? 'pbk-cv__star--full' : 'pbk-cv__star--empty';
      out += '<svg class="pbk-cv__star ' + cls + '" viewBox="' + STAR_VIEWBOX + '" fill="currentColor" aria-hidden="true">'
        + '<path d="' + STAR_PATH + '"/></svg>';
    }
    return out;
  }

  /* ---- レスポンスの防御的マッピング（フィールド欠落に耐える） ---- */
  function normalizeReview(r) {
    if (!r || typeof r !== 'object') return null;
    var user = r.user || r.reviewer || {};
    return {
      title: r.title || r.review_title || '',
      body: r.content || r.body || r.review_content || r.text || '',
      score: r.score != null ? r.score : (r.rating != null ? r.rating : r.review_score),
      date: r.created_at || r.date || r.created || r.review_date || '',
      author: user.display_name || user.name || r.display_name || ''
    };
  }

  function pickReviewsArray(json) {
    if (!json) return [];
    var resp = json.response || json;
    if (Array.isArray(resp.reviews)) return resp.reviews;
    if (resp.pagination && Array.isArray(resp.pagination.reviews)) return resp.pagination.reviews;
    if (Array.isArray(json.reviews)) return json.reviews;
    return [];
  }

  function pickTotal(json, fallback) {
    var resp = (json && json.response) || json || {};
    var pg = resp.pagination || {};
    var bottom = resp.bottomline || {};
    var candidates = [pg.total, bottom.total_review, resp.total_reviews, resp.total];
    for (var i = 0; i < candidates.length; i++) {
      var n = parseInt(candidates[i], 10);
      if (!isNaN(n) && n > 0) return n;
    }
    return fallback;
  }

  function averageScore(json, reviews) {
    var resp = (json && json.response) || json || {};
    var bottom = resp.bottomline || {};
    var avg = parseFloat(bottom.average_score);
    if (!isNaN(avg) && avg > 0) return avg;
    if (!reviews.length) return 0;
    var sum = 0, cnt = 0;
    reviews.forEach(function (r) {
      var s = parseFloat(r.score);
      if (!isNaN(s)) { sum += s; cnt++; }
    });
    return cnt ? sum / cnt : 0;
  }

  function fetchJson(url) {
    // same-origin: 同一オリジン(/products.json)へは cookie を送受する。パスワード保護中の
    // dev ストアで omit だと storefront_digest が付かず /password リダイレクトループ
    // (ERR_TOO_MANY_REDIRECTS)→失敗確定までレビュー表示が数秒遅延・常にサンプル fallback だった。
    // Yotpo CDN はクロスオリジンのため same-origin でも cookie は送られない（omit と同等）。
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
  }

  /* ---- サンプルレビュー（Yotpo 未設定 / 取得0件時の fallback。デザイン整合用） ---- */
  var SAMPLE_REVIEWS = [
    { title: 'ダイヤリング', body: 'このタイプ海外ではよくあるけども日本では意外と見ないデザインと日本らしさが良く融合されているなと気に入っています。ダイヤもどれもしっかり綺麗で満足です。', score: 5, date: '2026-04-29' },
    { title: 'パライバネックレス', body: '写真とも遜色がなく、むしろ実物の方がより素敵に見えました。この色味とサイズのパライバを他で買ったらこの値段では買えないと思いますしそういう意味でも良心的だと思います。よくジュエリーに明るい人に気づかれて褒められます。', score: 5, date: '2026-04-29' },
    { title: '可愛い', body: '親しみやすいライブや購入側の着画の要望にも快く接してくれる信用できるライブ。商品もサイコーに可愛い。そして安い！いつもありがとうございます。', score: 5, date: '2026-04-29' },
    { title: 'リピートしています', body: '何度か購入していますが、毎回丁寧な梱包と迅速な対応で安心してお買い物できます。石の質も良く、価格以上の価値を感じます。', score: 5, date: '2026-04-15' },
    { title: '一目惚れでした', body: 'ライブ配信で見た瞬間に一目惚れして購入。届いてからも毎日眺めては幸せな気持ちになっています。大切にします。', score: 5, date: '2026-04-02' }
  ];
  var SAMPLE_TOTAL = 59;
  var SAMPLE_AVG = 5;

  var CustomerVoice = class extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.appKey = (this.getAttribute('data-app-key') || '').trim();
      this.scope = this.getAttribute('data-scope') || 'site';
      this.perPage = parseInt(this.getAttribute('data-per-page'), 10) || 12;
      this.countSuffix = this.getAttribute('data-count-suffix') || 'レビュー';
      this.productIds = (this.getAttribute('data-product-ids') || '')
        .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

      this.track = this.querySelector('[data-cv-track]');
      this.countEl = this.querySelector('[data-cv-count]');
      this.summaryStarsEl = this.querySelector('[data-cv-summary-stars]');
      this.prevBtn = this.querySelector('[data-cv-prev]');
      this.nextBtn = this.querySelector('[data-cv-next]');

      this.index = 0;
      this.perView = this._perView();

      if (!this.track) return;

      if (this.prevBtn) this.prevBtn.addEventListener('click', this._prev.bind(this));
      if (this.nextBtn) this.nextBtn.addEventListener('click', this._next.bind(this));
      this._onResize = this._handleResize.bind(this);
      window.addEventListener('resize', this._onResize);
      this._bindDrag();

      // 見出し・集計枠は Liquid が初期描画済（hidden なし = 最初から表示）。
      // カードは即 fetch で最短表示（lazy 監視で遅延させない＝表示リグレッション対策）。
      // fetch は defer script の非同期処理なので初期描画自体はブロックしない。
      if (!this.appKey) { this._renderSample(); return; }
      this.load();
    }

    _renderSample() {
      this.render(SAMPLE_REVIEWS.slice(0, this.perPage), SAMPLE_TOTAL, SAMPLE_AVG);
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._onDown && this.track) this.track.removeEventListener('pointerdown', this._onDown);
    }

    _perView() {
      // SP は 1 枚/ビュー（1 枚 + チラ見せ）を横スワイプ、PC は 3 枚
      return window.matchMedia('(max-width: 749px)').matches ? 1 : 3;
    }

    load() {
      var self = this;
      // scope=product かつ 明示 product_ids 無し → ストア商品を集約し「商品レビューのみ」を表示
      // （ストアレビュー yotpo_site_reviews は含めない）
      if (this.scope === 'product' && !this.productIds.length) {
        var limit = parseInt(this.getAttribute('data-products-limit'), 10) || 24;
        fetchJson('/products.json?limit=' + limit).then(function (data) {
          var ids = ((data && data.products) || []).map(function (p) { return p.id; }).filter(Boolean);
          if (!ids.length) { self._renderSample(); return; }
          self._fetchReviews(ids.map(function (pid) { return ENDPOINTS.product(self.appKey, pid); }), true);
        }).catch(function () { self._renderSample(); });
        return;
      }
      var urls;
      if (this.scope === 'product' && this.productIds.length) {
        urls = this.productIds.map(function (pid) { return ENDPOINTS.product(self.appKey, pid); });
      } else {
        urls = [ENDPOINTS.site(this.appKey)];
      }
      this._fetchReviews(urls, this.scope === 'product');
    }

    _fetchReviews(urls, sortByDate) {
      var self = this;
      Promise.all(urls.map(function (u) {
        return fetchJson(u).catch(function () { return null; });
      })).then(function (results) {
        var reviews = [];
        var total = 0;
        var lastJson = null;
        results.forEach(function (json) {
          if (!json) return;
          lastJson = json;
          pickReviewsArray(json).forEach(function (r) {
            var n = normalizeReview(r);
            if (n && (n.body || n.title)) reviews.push(n);
          });
          total += pickTotal(json, 0);
        });

        if (!reviews.length) { self._renderSample(); return; } // 0件 → サンプル fallback

        if (sortByDate) {
          reviews.sort(function (a, b) {
            return (Date.parse(b.date) || 0) - (Date.parse(a.date) || 0);
          });
        }
        reviews = reviews.slice(0, self.perPage);
        var count = total || reviews.length;
        var avg = averageScore(lastJson, reviews);

        self.render(reviews, count, avg);
      }).catch(function () {
        self._renderSample(); // 失敗時 → サンプル fallback
      });
    }

    render(reviews, count, avg) {
      // 件数
      if (this.countEl) {
        this.countEl.textContent = String(count) + this.countSuffix;
      }
      // 集計星
      if (this.summaryStarsEl) {
        this.summaryStarsEl.innerHTML = starsSvg(avg);
      }
      // カード
      var html = reviews.map(function (r) {
        var title = escapeHtml(r.title) || '&nbsp;';
        var body = escapeHtml(r.body);
        var date = escapeHtml(formatDate(r.date));
        return '<article class="pbk-cv__card">'
          + '<h3 class="pbk-cv__card-title">' + title + '</h3>'
          + '<p class="pbk-cv__card-body">' + body + '</p>'
          + '<div class="pbk-cv__card-meta">'
          + '<span class="pbk-cv__stars">' + starsSvg(r.score) + '</span>'
          + (date ? '<span class="pbk-cv__card-date">' + date + '</span>' : '')
          + '</div>'
          + '</article>';
      }).join('');
      this.track.innerHTML = html;

      this.count = reviews.length;
      this.index = 0;
      // hidden は使わない（見出し・枠は初期表示・演出は見出しのみ通常フローで発火）。
      // カードに登場演出は付けない＝注入と同時に即表示。
      this._update();
    }

    _handleResize() {
      var pv = this._perView();
      if (pv !== this.perView) {
        this.perView = pv;
        this.index = 0;
        this._update();
      }
    }

    _maxIndex() {
      return Math.max(0, this.count - this.perView);
    }

    _prev() {
      this.index = Math.max(0, this.index - this.perView);
      this._update();
    }

    _next() {
      this.index = Math.min(this._maxIndex(), this.index + this.perView);
      this._update();
    }

    // 1 ステップ量 = 先頭カードの外形幅 + gap（calc 式に依存せず実測）
    _step() {
      var first = this.track && this.track.firstElementChild;
      if (!first) return 0;
      var cardW = first.getBoundingClientRect().width;
      var cs = window.getComputedStyle(this.track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return cardW + gap;
    }

    /* ---- タッチ / ポインタのスワイプドラッグ ---- */
    _bindDrag() {
      if (!this.track) return;
      this._onDown = this._pointerDown.bind(this);
      this._onMove = this._pointerMove.bind(this);
      this._onUp = this._pointerUp.bind(this);
      this.track.addEventListener('pointerdown', this._onDown);
    }

    _pointerDown(e) {
      if (e.button != null && e.button !== 0) return;   // 主ボタン/タッチのみ
      if (this._maxIndex() <= 0) return;                 // 1 画面に収まるなら不要
      var step = this._step();
      if (!step) return;
      this._drag = {
        x: e.clientX,
        y: e.clientY,
        base: -this.index * step,
        step: step,
        from: this.index,
        t: (window.performance && performance.now) ? performance.now() : Date.now()
      };
      this.track.style.transition = 'none';
      try { this.track.setPointerCapture(e.pointerId); } catch (_) {}
      window.addEventListener('pointermove', this._onMove);
      window.addEventListener('pointerup', this._onUp);
      window.addEventListener('pointercancel', this._onUp);
    }

    _pointerMove(e) {
      if (!this._drag) return;
      var max = this._maxIndex() * this._drag.step;
      var t = this._drag.base + (e.clientX - this._drag.x);
      if (t > 0) t = 0;
      if (t < -max) t = -max;                            // 端で止める
      this.track.style.transform = 'translateX(' + t + 'px)';
    }

    _pointerUp(e) {
      window.removeEventListener('pointermove', this._onMove);
      window.removeEventListener('pointerup', this._onUp);
      window.removeEventListener('pointercancel', this._onUp);
      if (!this._drag) return;
      var d = this._drag;
      var dx = e.clientX - d.x;
      var dy = (e.clientY || d.y) - d.y;
      var moved = d.base + dx;
      var step = d.step || 1;
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      var v = Math.abs(dx) / Math.max(1, now - d.t);     // px/ms
      this._drag = null;
      this.track.style.transition = '';                  // CSS の transition に復帰 → スナップ

      // 最近傍スナップ（= 大きくドラッグした時は複数枚送り）
      var next = Math.round(-moved / step);
      // 少ない移動量でも切り替える: 移動 40px 相当（またはカード 12%）を超える or 素早いフリック
      // → 進行方向へ 1 ページ送る。従来は「半カード幅(約168px)」超が必要でスムーズに切替できなかった。
      // ただし縦成分の方が大きい操作（= 縦スクロール意図。touch-action:pan-y でブラウザが
      // 縦パンを取り pointercancel が来るケース含む）では送らない
      var threshold = Math.min(40, step * 0.12);
      var horizontalIntent = Math.abs(dx) > Math.abs(dy);
      if (next === d.from && dx !== 0 && horizontalIntent && (Math.abs(dx) >= threshold || v >= 0.25)) {
        next = d.from + (dx < 0 ? this.perView : -this.perView);
      }
      this.index = Math.max(0, Math.min(this._maxIndex(), next));
      this._update();
    }

    _update() {
      if (!this.track || !this.count) return;
      var max = this._maxIndex();
      if (this.index > max) this.index = max;

      this.track.style.transform = 'translateX(' + (-this.index * this._step()) + 'px)';

      if (this.prevBtn) this.prevBtn.disabled = this.index <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index >= max;
      // スワイプ可能な時だけ grab カーソル / スワイプ捕捉
      this.classList.toggle('pbk-cv--draggable', max > 0);
    }
  };

  if (!customElements.get('pbk-customer-voice')) {
    customElements.define('pbk-customer-voice', CustomerVoice);
  }
})();
